export default __webpack_public_path__ + "static/1-1f8f19c302ef4628c940bad62b05ba70.mp4";